





































































import { Reports, User, Global } from '@/store';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Utils from '@/modules/Utils';
import { RETROFIT_STATE, PARTIAL_RETROFIT_STATE, PENDING_VERIFICATION_SYS_ACTIVE } from '@/modules/retrofitActions';

@Component({})
class DevicesListTable extends Vue {
    @Global.State('readonly_user') readonly_user;
    @Global.State('lang') lang;
    @Reports.Getter('commissionedFixtures') commissionedFixtures;
    @User.State('project') project;
    
    @Prop() selectedDevices;

    search = '';
    
    get headers() {
        return [
            { text: 'Device ID', sortable: false, class: [{'text-xs-left': this.lang === 'en'}, {'text-xs-right': this.lang !== 'en'}], value: 'id' },
            { text: 'Name', sortable: false, class: [{'text-xs-left': this.lang === 'en'}, {'text-xs-right': this.lang !== 'en'}], value: 'name' },
            { text: 'Pole Number', sortable: false, class: [{'text-xs-left': this.lang === 'en'}, {'text-xs-right': this.lang !== 'en'}], value: 'poleNumber' },
            { text: 'Location', sortable: false, class: [{'text-xs-left': this.lang === 'en'}, {'text-xs-right': this.lang !== 'en'}], value: 'location' },
            { text: 'Status', sortable: false, class: [{'text-xs-left': this.lang === 'en'}, {'text-xs-right': this.lang !== 'en'}], value: 'status' }
        ];
    }

    get items(){
        return this.commissionedFixtures.map((device) => this.generateRowData(device));
    }

    // Row objects are rendered by iterating their entries into <td>s, so the
    // retrofit flag is kept outside of them to avoid adding a phantom column.
    get retrofit_ids(){
        return new Set(
            this.commissionedFixtures
                .filter((device) => !Utils.isDeviceLive(device))
                .map((device) => device.id)
        );
    }

    isUnderRetrofit(item){
        return this.retrofit_ids.has(item.id);
    }

    isRowDisabled(item){
        return this.readonly_user || this.isUnderRetrofit(item);
    }

    generateRowData(device){
        const rowData = {
            id: device.id,
            name: device.name,
            poleNumber: device['meta.device'].pole_number || '-',
            location: `(${device['meta.location'].lat.toFixed(3)} , ${device['meta.location'].lng.toFixed(3)})`,
            status: this.getDeviceStatusText(device)
        };

        return rowData;
    }

    getDeviceStatusText(device){
        // Retrofit is an operation state, so it comes off the operation state. Pending
        // Verification is not one - it's the sys___active sentinel, so it's resolved by
        // getStatusText below along with every other connectivity value.
        const operation_state = Utils.getOperationState(device);
        if (operation_state === RETROFIT_STATE || operation_state === PARTIAL_RETROFIT_STATE) {
            return 'Retrofit';
        }
        return this.getStatusText(device.sys___active);
    }

    getStatusText(sys_active){
        return sys_active === 1 
            ? 'Connected'
            : sys_active === -9
                ? 'Fault In Care'
                : sys_active === -1
                    ? 'Maintenance'
                    : sys_active === 0
                        ? 'Disconnected'
                        : sys_active === -3
                            ? 'In Installation'
                            : sys_active === PENDING_VERIFICATION_SYS_ACTIVE
                                ? 'Pending Verification'
                                : 'Unknown';
    }
    
    updateSelected(selected, item){
        selected = !selected; 
        const newSelected = selected ? this.selectedDevices.concat([item]) : this.removeItem(item);
        this.$emit('selectedChanged', newSelected);
    }

    removeItem(item){
        const index = this.selectedDevices.indexOf(item);
        return this.selectedDevices.slice(0, index).concat(this.selectedDevices.slice(index + 1));
    }

    toggleAll(){
        const selectable = this.items.filter((item) => !this.isUnderRetrofit(item));
        const newSelected = this.selectedDevices.length === selectable.length ? [] : selectable;
        this.$emit('selectedChanged', newSelected);
    }
    
}

export default DevicesListTable;
